<script>
  import Datas from './Data.svelte';
  import { onMount } from 'svelte';
  import AutoComplete from "simple-svelte-autocomplete";
  
  export let form_id = null;
  export let data_key = null;
  export let operator = null;
  export let itemsForPrintFn = null;
  
  let updated_at = null;
  let forms = [];
  let active = null;
  
  function fetchForms() {
    if (!form_id) return;
    fetch(`/data/${form_id}/children.json`)
      .then(r => r.json())
      .then(data => {
        if (!recallOption(data.data))
          active = 0;
        forms = data.data;
      });
  }
  
  function rememberOption(e) {
    if (active)
      localStorage.setItem('data+'+form_id, JSON.stringify({id: active.id}));
  }
  
  function recallOption(_forms) {
    var data = localStorage.getItem('data+'+form_id);
    if (data) {
      data = JSON.parse(data);
      for (let i in _forms)
        if (_forms[i].id == data.id) {
          active = _forms[i];
          return true;
        }
    }
    return false;
  }
  
  
  onMount(fetchForms);
</script>
{#if forms && forms.length}
<AutoComplete bind:selectedItem='{active}' inputClassName='ui form-control' items='{forms}' labelFieldName='name' matchAllKeywords='{false}' onChange='{rememberOption}' showClear sortByMatchedKeywords='{true}'></AutoComplete>
{/if}
{#if active && active.id}
<slot name='head'></slot>
{#if data_key}
<Datas form_id='{active.id}' itemsForPrintFn='{itemsForPrintFn}' let:index='{index}' let:item='{item}' let:updated_at='{updated_at}' operator='{operator}' root='{data_key}'>
<slot index='{index}' item='{item}' name='body' updated_at='{updated_at}'></slot>
</Datas>
{/if}
{/if}
